<template lang="pug">
div
  modal-assign-to(:supplierId="supplierId" :form="form" :isVisible="isModalAssignToVisible" @closeModal="closeModalAssignTo" @updateRecords="updateView")
  modal-concepts(:form='selectedConcept' :is-add='isModalConceptsAdd' :supplierName='supplier.name' :isVisible="isModalConceptsVisible" @closeModal="closeModalConcepts" @updateRecords="updateView")
  button.back(@click="goSupplier")
    vm-icon(icon="arrow-back-outline" size="2rem")
  div.dashboard
    div#header
      div.title
        h2.title_item {{ $t('strings.supplier_reception') }}
        img.icon(src="@/assets/truck.svg" style="transform: scaleX(-1);")
    div.supplier_statistics
      div.main_statistic
        div.side_color(style="background-color: #e0e0e0")
        div(style="padding-left: 3rem;")
          strong.project_name {{ supplier.name}}
          span.location {{ supplier.location }}
          span.project_date {{ supplier.created_at | moment("DD MMMM YYYY") }}
      div.statistic
        div.side_color(style="background-color: #a5170f")
        span.statistic_text {{ $t('suppliers_dashboard.available_balance')}}
        strong.statistic_number {{ supplier.available_balance | currency}}
      div.statistic
        div.side_color(style="background-color: #bb8700")
        span.statistic_text {{ $t('suppliers_dashboard.total_investment')}}
        strong.statistic_number {{ supplier.income | currency}}
    br
    h2#table_title {{ $t('suppliers_dashboard.advance_payment') }}
    button.add_button
      div.button_div(@click="showModalAssignTo")
        span.button_span &nbsp; {{ $t('suppliers_dashboard.assign_to') }}
        vm-icon.button_icon(icon="undo-outline" size="1.3rem")
    button.add_button(@click="showModalConcepts")
      div.button_div
        vm-icon.button_icon(icon="plus-outline" size="1.3rem")
        span.button_span &nbsp; {{ $t('suppliers_dashboard.add_deposit') }}
    br
    br
    SupplierConcepts(ref="SupplierConcepts" @updateScoreCard="reloadStatistics")
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
const { mapGetters, mapActions } = createNamespacedHelpers('Suppliers')
const ModalAssignTo = () => import('@/components/modals/ModalAssignTo.vue')
const ModalConcepts = () => import('@/components/modals/ModalConcepts.vue')

export default {
  components: {
    ModalAssignTo,
    ModalConcepts,
    SupplierConcepts: () => import('@/components/dashboard/suppliers/SupplierConcepts.vue')

  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    form: {
      project_id: '',
      amount: ''
    },
    currentPage: 1,
    date: '',
    columns: ['date', 'concept', 'payment', 'charge', 'status'],
    isModalAssignToVisible: false,
    supplierId: 0,
    isModalConceptsAdd: true,
    isModalConceptsVisible: false,
    selectedConcept: {},
    updateConcepts: true
  }),
  computed: {
    ...mapGetters([
      'supplier'
    ])
  },
  created () {
    this.loadRecord({ id: this.$route.params.id })
  },
  methods: {
    ...mapActions([
      'loadRecord',
      'updateRecord'
    ]),
    showModalAssignTo () {
      this.form = {}
      this.supplierId = this.supplier.id
      this.isModalAssignToVisible = true
    },
    goSupplier () {
      this.$router.push({ name: 'suppliers' })
    },
    closeModalAssignTo () {
      this.isModalAssignToVisible = false
    },
    showModalConcepts () {
      this.isModalConceptsVisible = true
      this.isModalConceptsAdd = true
      this.selectedConcept = {
        date: moment().format('YYYY-MM-DD'),
        conceptable_type: 'App\\Models\\Supplier',
        conceptable_id: this.supplier.id,
        concept: '',
        payment: 0,
        charge: 0,
        status: 1
      }
    },
    updateView (concept, isAdd) {
      this.$refs.SupplierConcepts.updateTable(concept, isAdd)
    },
    async reloadStatistics () {
      setTimeout(async () => {
        await this.loadRecord({ id: this.$route.params.id })
      }, 100)
    },
    closeModalConcepts () {
      this.isModalConceptsVisible = false
    }
  }
}
</script>
<style scoped lang="scss">
@import '../components/dashboard/suppliers/supplier_dashboard_structure.css';
.dashboard {
  background-color: #fafafa;
  padding: 0 5rem 0 5rem;
}

#table_title {
  float: left;
}
.add_button {
  float: right;
  border: solid black 1px;
  border-radius: 0.4rem;
  margin: 0 0.4rem 0 1rem;
  width: 12rem;
  padding: 0.3rem 0.7rem 0.3rem 0.7rem;
  color: white;
  background-color: black;
  cursor: pointer;
}
.button_div {
  display: flex;
}
.button_span {
  min-width: 7rem;
}
.button_icon {
  transform: scaleX(-1);
  display: block;
  padding-top: 0.2rem;
}
</style>
